import React from 'react';
import { Button, Modal } from 'antd';
import { assoc, compose, concat, difference, flatten, isNil, map, prop, propEq, propOr, isNotEmpty } from 'ramda';
import { isNilOrEmpty, notEqual } from 'ramda-adjunct';
import WidgetForm from '../widget/WidgetForm';
import { QWidgetQuery } from '../../../../_graphql/queries/documents/QWidget';
import useFetchQuery from '../../../../hooks/useFetchQuery';
import Loading from '../../../../components/Loading';
import { useDocumentContext } from '../../../../context/Document';
import UpdateCacheMutation from '../../../../_graphql/mutations/UpdateCacheMutation';
import { getVariablesOnWidgetHtml } from '../../../helpers/getVariablesOnWidgetHtml';

const EditWidgetModal = ({ totalPaddingX }) => {
  const {
    widgetIdEditing,
    setWidgetIdEditing,
    widgetEditOrigin,
    offerId,
    documentId,
    setWidgets,
    widgets,
    globalVariables,
    setGlobalVariables,
    values,
    variables
  } = useDocumentContext();

  const { widget, isLoading, reFetch } = useFetchQuery({
    query: QWidgetQuery,
    args: { widgetId: widgetIdEditing },
    dataProp: 'widget',
    defaultData: {}
  });
  const onCancel = () => setWidgetIdEditing(undefined);

  const updateWidget = (values, name) => {
    const variablesOnOldWidget = getVariablesOnWidgetHtml(JSON.parse(propOr([], 'contents', widget)), globalVariables);
    const variablesOnUpdatedWidget = getVariablesOnWidgetHtml(propOr([], 'contents', values), globalVariables);
    const diffVariables = compose(
      flatten,
      () => concat(difference(variablesOnOldWidget, variablesOnUpdatedWidget), difference(variablesOnUpdatedWidget, variablesOnOldWidget))
    )();

    const updateWidgetData = w => {
      if (propEq(widgetIdEditing, 'id', w)) {
        let updatedWidget = w;
        if (isNotEmpty(diffVariables)) {
          updatedWidget = compose(
            assoc('variables', variablesOnUpdatedWidget),
            assoc('contents', JSON.stringify(prop('contents', values)))
          )(updatedWidget);
        }
        if (notEqual(prop('name', widget), name)) {
          updatedWidget = assoc('name', name, updatedWidget);
        }
        return updatedWidget;
      }
      return w;
    };

    const widgetsUpdated = map(updateWidgetData, widgets);
    setWidgets(widgetsUpdated);
    UpdateCacheMutation({ date: new Date(), key: `widgets-${offerId}` }, () => {});
  };

  return (
    <Modal
      className="modal-widget"
      open={!isNil(widgetIdEditing)}
      footer={null}
      onCancel={onCancel}
      width="99%"
      destroyOnClose
      maskClosable={false}
      keyboard={false}
      centered
      bodyStyle={{ height: '90vh', overflowY: 'auto' }}
    >
      {
        isNilOrEmpty(widget)
          ? isLoading
            ? <Loading />
            : (
              <div>
                {'Le widget n\'existe pas.'}
                <Button onClick={onCancel}>Fermer</Button>
              </div>
            )
          : (
            <WidgetForm
              widget={widget}
              scope={prop('scope', widget)}
              modalMode
              onCancel={onCancel}
              hideModal={onCancel}
              documentId={documentId}
              offerId={offerId}
              setRefetch={reFetch}
              totalPaddingX={totalPaddingX}
              updateWidget={updateWidget}
              globalVariables={globalVariables}
              setGlobalVariables={setGlobalVariables}
              origin={widgetEditOrigin}
              pages={propOr([], 'pages', values)}
              documentVariables={variables}
            />
          )
      }
    </Modal>
  );
};

export default EditWidgetModal;
